<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="productDatingInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-radio-group
            label="Were the affected Lots declined within 24 hours of IDOC/Order Confirmation receipt?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="declinedWithin24Hours" formControlName="declinedWithin24Hours" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="declinedWithin24Hours" formControlName="declinedWithin24Hours" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (isTrue('declinedWithin24Hours')) {
        <app-attachments-input
            [form]="productDatingInternationalForm!"
            [required]="true"
            controlName="communicationDeclinedDocuments"
            label="Attach a copy of the communication declining the batch"
        />
        } @if (isFalse('declinedWithin24Hours')) {
        <sag-ui-radio-group label="Does Batch Expiry meet Min Ship Policy?" direction="row" [required]="true">
            <sag-ui-radio
                name="batchExpiryMeetsMinShipPolicy"
                formControlName="batchExpiryMeetsMinShipPolicy"
                [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio
                name="batchExpiryMeetsMinShipPolicy"
                formControlName="batchExpiryMeetsMinShipPolicy"
                [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (isTrue('batchExpiryMeetsMinShipPolicy')) {
        <div class="rounded-md bg-shs-red grid grid-cols-[50px_auto] shadow-md items-center p-4 max-w-[950px]">
            <span class="icon-circle-error text-white text-3xl"></span>
            <span class="text-white text-sm font-bold pr-8"
                >Batch above Export Min Ship Policy. The option to request a financial adjustment (credit) is not
                available.</span
            >
        </div>
        } }@if (showFinancialAdjustment) {
        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        } @if(showRelatedDocuments) {
        <app-attachments-input [form]="productDatingInternationalForm!" controlName="relatedDocuments" />
        }
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
